import React from 'react';
import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';
import { Box } from '@mui/material';
import { ImageDimensions } from '../utils/imageEditConstants';

interface CanvasAreaProps {
  canvasRef: React.RefObject<ReactSketchCanvasRef | null>;
  backgroundImage: string | null;
  displayDimensions: ImageDimensions;
  canvasReady: boolean;
  strokeWidth: number;
  strokeColor: string;
  onStrokeEnd: () => void;
}

export const CanvasArea: React.FC<CanvasAreaProps> = ({
  canvasRef,
  backgroundImage,
  displayDimensions,
  canvasReady,
  strokeWidth,
  strokeColor,
  onStrokeEnd
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        overflow: 'auto',
        position: 'relative',
        background: '#ffffff',
        backgroundImage: 'linear-gradient(45deg, #f0f0f0 25%, transparent 25%), linear-gradient(-45deg, #f0f0f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f0f0f0 75%), linear-gradient(-45deg, transparent 75%, #f0f0f0 75%)',
        backgroundSize: '20px 20px',
        backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
      }}>
      <Box
        sx={{
          position: 'relative',
          width: displayDimensions.width,
          height: displayDimensions.height,
          border: '2px dashed #2196f3',
          borderRadius: '8px',
          overflow: 'hidden',
          backgroundColor: '#ffffff',
          boxShadow: 3,
        }}>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}>
          {backgroundImage && (
            <Box
              component='img'
              src={backgroundImage}
              alt='Hintergrundbild'
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                zIndex: 1,
                pointerEvents: 'none',
              }}
            />
          )}

          {canvasReady && (
            <ReactSketchCanvas
              ref={canvasRef}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 2,
                backgroundColor: 'transparent',
              }}
              width={`${displayDimensions.width}px`}
              height={`${displayDimensions.height}px`}
              strokeWidth={strokeWidth}
              strokeColor={strokeColor}
              allowOnlyPointerType='all'
              canvasColor='transparent'
              onStroke={onStrokeEnd}
            />
          )}
        </Box>
        
        {!canvasReady && (
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 2,
              color: '#666',
              fontSize: { xs: '0.875rem', sm: '1rem' },
            }}
          >
            Canvas wird geladen...
          </Box>
        )}
      </Box>
    </Box>
  );
};
